import { useChannelTalk } from '@repo/channel-talk';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import ErrorHometaxCommonView from '@/components/tax-refund/common/view/ErrorView/ErrorHometaxCommonView';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

const ResultRequestHometaxErrorPage = () => {
  const { openChannelTalk } = useChannelTalk();
  const router = useRouter();

  const handleRetry = () => {
    router.push({
      pathname: `${COMMON_PATHS.환급결정확인알림톡}`,
      query: router.query
    });
  };

  const handleAsk = () => {
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <Layout>
      <ErrorHometaxCommonView
        viewController={{
          moveBackPage: handleRetry,
          handleAsk: handleAsk
        }}
      />
    </Layout>
  );
};

export default ResultRequestHometaxErrorPage;
